module.exports = __webpack_public_path__ + "static/media/orthotoolkit.e1225357.png";


//////////////////
// WEBPACK FOOTER
// ./src/orthotoolkit.png
// module id = 282
// module chunks = 0